var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxShieldSecurityBasicOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9661 16.879L10.3126 17.1338C10.0769 17.2221 9.81716 17.2221 9.58147 17.1338L8.92792 16.879C7.27255 16.23 5.85067 15.098 4.84714 13.6303C3.84359 12.1625 3.3048 10.4268 3.30078 8.64873V5.56931C4.55525 5.7481 5.83471 5.58523 7.00439 5.09786C8.17406 4.6105 9.19064 3.81669 9.94701 2.80005C11.3316 4.81607 13.6246 5.7687 16.5932 5.56931V8.64873C16.5893 10.4268 16.0505 12.1625 15.0469 13.6303C14.0433 15.098 12.6215 16.23 10.9661 16.879Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxShieldSecurityBasicOutline);
export default __webpack_public_path__ + "static/media/icon_20px_shield-security-basic_outline.61dcd3ceeeee5899504e9695f5889b15.svg";
export { ForwardRef as ReactComponent };